import { Navigate } from 'react-router-dom';
import ROUTES from '../../../../core/constants/routes.constants';

function Logout() {
  return <Navigate to={ROUTES.root} />;
}

export default Logout;
